import React, { useEffect, useState } from "react";
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
import { FaCaretDown } from "react-icons/fa";
import ResponsiveMenu from "./ResponsiveMenu";
import { FaMoneyBillWave } from "react-icons/fa";
import { socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";
import { Link } from "react-router-dom";
import { useBalance } from "../../pages/BalanceContext";

const Navbar2 = () => {
  const [theme, setTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "light",
  );
  const [showMenu, setShowMenu] = useState(false);

  const element = document.documentElement;
  const { balance } = useBalance();
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = () => {
    localStorage.removeItem("userInfo");

    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.close();
    } else {
      window.location.href = "/";
    }
  };

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  return (
    <>
      <div
        className="
relative z-[99]
border-b border-yellow-500/30
bg-gradient-to-r
from-[#0F172A]
via-[#1E293B]
to-[#111827]
text-white
shadow-[0_8px_30px_rgba(0,0,0,0.45)]
backdrop-blur-md
"
      >
        <header data-aos="fade" data-aos-duration="300" className="">
          <nav className="container  flex h-[70px] items-center justify-between py-1">
            <div className="text-2xl text-yellow-400 md:text-3xl font-serif">
              <a href="/" className="">
                Habesha
                <span className="inline-block font-bold text-white font-serif">
                  Bet
                </span>
              </a>
            </div>
            {/* Desktop Menu */}
            <div className="hidden md:block">
              <ul className="flex items-center gap-10 font-serif">
                <li className="cursor pointer">
                  <a href="/">home</a>
                </li>
                <li className="cursor pointer">
                  <a href="/HowToWin">How Win</a>
                </li>
                <li className="cursor pointer">
                  <a href="/referralIncome">Referral_Income</a>
                </li>
                <li className="cursor pointer">
                  <a href="/leaderboard">LeaderBoard</a>
                </li>
                <li className="cursor pointer">
                  <a href="https://t.me/Ethiopiagames_bot">Contact Us</a>
                </li>
                {/* Phone number section */}
                <div className="flex items-center gap-4">
                  <li>
                    <FaMoneyBillWave className="h-[40px] w-[40px] rounded-md bg-primary p-2 text-2xl text-white hover:bg-primary/90" />
                  </li>
                  <li>
                    <div>
                      <p className="text-sm">ETB</p>
                      <p className="text-lg">
                        {" "}
                        <a href="/wallet">{balance}</a>
                      </p>
                    </div>
                  </li>
                </div>

                <li className="group relative cursor-pointer">
                  <a href="/" className="flex h-[72px] items-center gap-[2px]">
                    {userInfo?.username}
                    <span>
                      <FaCaretDown className="transition-all duration-200 group-hover:rotate-180" />
                    </span>
                  </a>
                  <div className="absolute -left-9 z-[9999] hidden w-[150px] rounded-md bg-white p-2 text-black group-hover:block  ">
                    <ul className="space-y-3">
                      <li>
                        <a
                          href="/wallet"
                          className="p-2 hover:bg-violet-200 block"
                        >
                          Wallet
                        </a>
                      </li>
                      <li>
                        <a
                          href="/profile"
                          className="p-2 hover:bg-violet-200 block"
                        >
                          Profile
                        </a>
                      </li>
                      <li>
                        <a
                          href="/history"
                          className="p-2 hover:bg-violet-200 block"
                        >
                          Game History
                        </a>
                      </li>
                      <li></li>
                      <li>
                        <a
                          onClick={handleLogout}
                          className="p-2 hover:bg-violet-200 block"
                        >
                          Log out
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>

            {/* Mobile view  */}
            <div className="flex items-center gap-4 md:hidden ">
              <Link
                to="/wallet"
                className="
            inline-flex items-center gap-2
            px-4 py-2
            rounded-full
            border border-primary/50
            bg-gradient-to-l from-cyan-950 via-cyan-800 to-cyan-950
            text-white font-semibold text-sm
            shadow-lg
            hover:shadow-xl hover:scale-105
            transition-all duration-200
            active:scale-95
          "
              >
                <span className="text-sm">ETB {balance}</span>
              </Link>
              {showMenu ? (
                <HiMenuAlt1
                  onClick={toggleMenu}
                  className=" cursor-pointer transition-all"
                  size={30}
                />
              ) : (
                <HiMenuAlt3
                  onClick={toggleMenu}
                  className="cursor-pointer transition-all"
                  size={30}
                />
              )}
            </div>
          </nav>
        </header>
      </div>
      <ResponsiveMenu showMenu={showMenu} />
    </>
  );
};

export default Navbar2;
